import * as angular from 'angular';

const module = angular.module('tradersyard');

require('./attachments/copy-paste-files.service').default(module);
